import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DashboardSliderCard } from 'C4';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const NextArrow = ({ className, onClick }) => (
  <button type="button" className={className} onClick={onClick}>
    <FontAwesomeIcon icon={['fas', 'chevron-right']} />
  </button>
);

const PrevArrow = ({ className, onClick }) => (
  <button type="button" className={className} onClick={onClick}>
    <FontAwesomeIcon icon={['fas', 'chevron-left']} />
  </button>
);

const DashboardSlider = ({ items, type, title }) => {
  const { train } = items;
  // console.log(items);
  const sliderSettings = {
    infinite: false,
    speed: 700,
    slidesToShow: 5,
    slidesToScroll: 4,
    adaptiveHeight: true,
    autoplay: false,
    draggable: true,
    cssEase: 'linear',
    nextArrow: <NextArrow className="slider-next" />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 880,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  console.log(train);

  return (
    <div className={type}>
      <div className="title">
        <h1>{title}</h1>
        <hr className="shortLine" />
      </div>
      {items && (
        <Slider {...sliderSettings}>
          {train.map((item) => (
            <DashboardSliderCard key={item.chapterID} item={item} itemType="Train Sessions" sliderType={type} />
          ))}
        </Slider>
      )}
    </div>
  );
};

DashboardSlider.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  items: PropTypes.shape({
    train: PropTypes.arrayOf(PropTypes.objectOf).isRequired,
  }).isRequired,
};

DashboardSlider.defaultProps = {
  type: '',
  title: '',
};

export default DashboardSlider;
